import { useState, useEffect } from 'react';
import { getMyPdvs } from '../services/users/usersApi';

/**
 * Hook para buscar PDVs do usuário logado
 *
 * @returns {Object} { pdvs, isLoading, error }
 *
 * Uso:
 * const { pdvs, isLoading } = useUserPdvs();
 *
 * A leitura do envelope (e a ponte de shape do handoff 0110) vive no service
 * `users/usersApi.getMyPdvs` — este hook só administra o ciclo de vida.
 *
 * ⚠️ Em caso de FALHA a lista volta vazia, e quem consome precisa saber
 * distinguir "não tem PDV" de "não deu para carregar": `Transfers/utils/
 * pdvAccess.js` deriva acesso desta lista e trata o erro explicitamente.
 */
export function useUserPdvs() {
   const [pdvs, setPdvs] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [error, setError] = useState(null);

   useEffect(() => {
      async function loadPdvs() {
         try {
            setIsLoading(true);
            const { pdvs: list } = await getMyPdvs();
            setPdvs(list);
         } catch (err) {
            console.error('Erro ao carregar PDVs do usuário:', err);
            setError(err);
            setPdvs([]); // Array vazio em caso de erro
         } finally {
            setIsLoading(false);
         }
      }

      loadPdvs();
   }, []);

   return { pdvs, isLoading, error };
}

export default useUserPdvs;
